import { FormStore } from "../../stores/FormStore";
import * as React from "react";
import {observer} from "mobx-react";
import {CrudComponent} from "./CrudComponent";
import Form from "../form/Form";
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


@observer
export class CrudForm extends CrudComponent {
    id = null;
    formStore: FormStore<any>;
    entity: any;
    showSubmitButton: boolean = true;
    default_role = '';
    defaultRole : any;

    loadMoreData(props: any, module: any) {

    }

    

    load(props: any, module: any) {
        this.id = props.id;
        const formDataClass = module[this.modelName + 'FormData'];
		
        this.formStore = new FormStore<any>(new formDataClass());
		 
        this.formStore.onSubmitCallback = this.postData;
        this.getData();
        this.loadMoreData(props, module);
    }

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await this.api.getDetailAction(this.id).then((data: any) => {
                this.formStore.setData(data);
                this.entity = data;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };
     
   // notify = () => toast("Hello", { autoClose: false });
    
    postData = (data: any) => {
        // TODO id optional
		//  console.log("postData-> " , data);
	// 	let isvalidte = false;
		
        return this.api.postFormAction(this.id || '', data).then((response: any) => {
            // toast.success('successful', {autoClose:3000});
               toast.success('Record Saved successfully!');
			   		//	isvalidte = true;
               this.props.onSubmit(response);
			   		   
			   
			   
        }); /* .catch((e:any ) => { if(!isvalidte) { toast.error('Error while processing'); } } ) */
    };

    render() {
        if (this.isLoading) {
            return <div>Loading ...</div>;
        }

        const fields = this['renderFields'] && this['renderFields']();

        return (
            <Form store={this.formStore} showSubmitButton={this.showSubmitButton}>
                {fields}
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/crud/CrudForm.tsx